import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import type { PdfRenderRequest } from '../../types';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class PdfReportService {
  private readonly api = inject(ApiService);

  render(request: PdfRenderRequest): Observable<Blob> {
    return this.api.postBlob('v1/render', request, { resource: 'pdf-report-api' });
  }
}
